module.exports = __webpack_public_path__ + "67f0a21552d30fd4d238b7f512508975.png";